export default __webpack_public_path__ + "static/media/LEGA9029.ea90600e.jpg";